<template lang="pug">
  .server-down
    .text-center
      h1 504
      h1 Server is down
      h2 Connection attempts: {{ conntectionAttempts }}
      i.fa.fa-cog.fa-spin.fa-5x
</template>

<script>
import Auth from '@/service/AuthService'

export default {
  data: () => ({
    conntectionAttempts: 0
  }),
  destroyed() {
    clearTimeout(this.timeout)
  },
  created() {
    this.reconnect()
  },
  methods: {
    reconnect() {
      Auth.refreshContext()
        .then(() => {
          this.$emit('serverUp')
        })
        .catch((e) => {
          if (![502, 503, 504].includes(e.response.status)) {
            this.$emit('serverUp')
            return
          }
          this.conntectionAttempts += 1
          this.timeout = setTimeout(() => {
            this.reconnect()
          }, 10000)
        })
    }
  }
}
</script>

<style lang="scss">
$kezzler-blue: #004FE1;
$kezzler-white: #FFFFFF;
.server-down {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: $kezzler-white;
  background-color: $kezzler-blue;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ServerDown.vue